// polyfills
import picturefill from 'picturefill';
// import objectFitPolyfill from 'objectFitPolyfill';

// pages & components
import lazy from './scripts/lazyload';
import carousel from './scripts/carousel';
import navigation from './scripts/navigation';
import accordion from './scripts/accordion';
import rApp from './scripts/rapp'

import productCard from './scripts/modules/productCard';
import tabbedCollection from './scripts/modules/tabbedCollection';
import shipDateCard from './scripts/modules/shipDateCard';

import account from './scripts/pages/account';
import faq from './scripts/pages/faq';
import product from './scripts/pages/product';
import embGuide from './scripts/pages/emb-guide';
class App {
  constructor() {
    lazy.init();

    // navigation
    navigation.init();

    // React / Minicart
    rApp.init()

    // carousels
    carousel.init();

    // accordion
    accordion.init();

    // tabbedCollection
    tabbedCollection.init();

    // product page
    product.init();
    
    //emb-applique-guide
    embGuide.init();

    // product cards
    productCard.init();

    // holiday shipping cards
    shipDateCard.init();

    // account page
    account.init();

    // faq page
    faq.init();
  
    // polyfills
    // 'srcset' and <picture>
    picturefill();
    // object-fit
    // objectFitPolyfill();
  }
}

const app = new App();